import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  ChartOptions,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip);
interface ComplaintCategoryReportProps {
  data: any;
  options?: ChartOptions<"bar">;
  title: string;
}
const ComplaintCategoryReport: React.FC<ComplaintCategoryReportProps> = ({
  data,
  options,
  title
}) => {
  
  return (
    <div className="bg-white rounded-lg shadow-md w-full lg:h-[400px]">
      <div className="p-4 text-md font-semibold text-gray-600 border-b border-gray-300 pb-2">
        {title}
      </div>
      <div className=" m-4 lg:h-[320px] aspect-w-3 aspect-h-2 px-6">
        <Bar data={data} options={options} />
      </div>
    </div>
  );
};

export default ComplaintCategoryReport;
